// src/components/OnePage/OnePage-ApprovalBanner.js

// ### IMPORTS GENERAL
import React from "react";
import { Tooltip } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import PropTypes from "prop-types";

// ### ONE PAGE | COMPONENT: APPROVAL BANNER STATUS
const OnePageAlertBanner = ({ approved, comment, t }) => {
  // 1. Adicione 't' aos props

  // Se o status for "approved" (que vem do backend quando não há nada pendente)
  // ou se não houver status definido, não mostramos nada.
  if (!approved || approved === "approved") {
    return null;
  }

  // 2. Mapeamento de propriedades para cada status (pending, yes, no)
  const statusConfig = {
    pending: {
      severity: "info",
      labelKey: "onepage.approval_pending", // Chave de tradução para "Approval Pending"
      bgColor: "#e1f5fe", // Azul claro para informação
    },
    yes: {
      severity: "success",
      labelKey: "onepage.approved", // "Approved"
      bgColor: "#d0e9c6",
    },
    no: {
      severity: "warning",
      labelKey: "onepage.not_approved", // "Not Approved"
      bgColor: "#faf2cc",
    },
  };

  // Pega a configuração para o status atual, ou usa 'pending' como fallback seguro.
  const config = statusConfig[approved] || statusConfig.pending;

  return (
    <Alert
      severity={config.severity}
      style={{
        backgroundColor: config.bgColor,
        margin: "5px 0 -3px",
        padding: "2px 8px",
        width: "100%",
        overflow: "hidden",
        boxSizing: "border-box",
        boxShadow: "none",
        minHeight: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          whiteSpace: "nowrap",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <span
          style={{
            flexShrink: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: 500, // Dando um pouco mais de destaque
          }}
        >
          {t(config.labelKey)}
        </span>
        {comment && (
          <>
            <span style={{ marginLeft: 8, whiteSpace: "nowrap" }}>
              {t("onepage.comment")}: {/* Chave de tradução para "Comment" */}
            </span>
            <Tooltip title={comment} arrow>
              <span
                style={{
                  marginLeft: 4,
                  maxWidth: "70%",
                  fontStyle: "italic",
                  flexShrink: 1,
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                }}
              >
                {comment}
              </span>
            </Tooltip>
          </>
        )}
      </div>
    </Alert>
  );
};

OnePageAlertBanner.propTypes = {
  approved: PropTypes.oneOf(["yes", "no", "pending", "approved"]),
  comment: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default OnePageAlertBanner;
